export default {
    pageTitle: 'Activations',
    orderNumber: 'Commande #',
    license: {
        unactivated: 'licences non activées',
        activate: 'Activez une nouvelle licence',
        order_number: 'Numéro de commande',
    },
    form: {
        androidVersion: 'Version d\'Android',
        phoneModel: 'Modèle de téléphone',
        productSerialNumber: 'Clé AFS',
    },
    name: 'Activations',
    list: {
        afsVersion: 'Version d\'AFS',
        date: "Date d'activation",
        deviceSerialNumber: 'Numéro de série de l\'appareil',
        firmwareVersion: 'Version du firmware',
        type: 'Type de licence',
    },
};
